import { render, staticRenderFns } from "./MaterialTypeDetail.vue?vue&type=template&id=679cae8a&scoped=true&"
import script from "./MaterialTypeDetail.vue?vue&type=script&lang=js&"
export * from "./MaterialTypeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679cae8a",
  null
  
)

export default component.exports